import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { sportIds } from 'src/constants'
import { leagueGroupIds } from 'src/constants/personalizationIds'
import { canadaPlanSet, canadaSports_EPL_UCL_Override } from 'src/constants/planData/canadaPlanData'
import { subtitleText } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      // video={
      //   'https://assets.fubo.tv/marketing/lp/videos/compressed/Tottenham2022_1280x720_LP_15s.mp4'
      // }
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/EPL/EPL_Tottenham_Hero_Desktop.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/EPL/EPL_Tottenham_Hero_Mobile.jpg"
      title="Watch Tottenham soccer live"
      subtitle={subtitleText.epl}
      planCardsConfig={{
        plans: canadaPlanSet.sports,
        overrides: canadaSports_EPL_UCL_Override,
      }}
      networkSet="canada_sports"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-epl-white.png?ch=width&auto=format,compress"
      logoHeight="90px"
      team="Tottenham"
      soccerPlanCardImage="https://assets-imgx.fubo.tv/marketing/lp/images/card/canada/ca_card_toronto-spurs.jpg?w=451&ch=width&auto=format,compress"
      // hasScheduleBanner={true}
      matchtickerSportId={sportIds.Soccer}
      matchtickerLeagueName="Multiple Sports"
      matchtickerLeagueId={leagueGroupIds.canada_soccer}
    />
  )
}
